<script>
    import FAQ from '../components/FAQ.svelte'

    const FAQS_LIST = [
        {
            question: '¿De dónde sale el diseño de esta pantalla?',
            answer: `Esta pantalla ha sido diseñada por Prusa Research. Nosotros la hemos simplificado un poco por eficiencia. 
            Puedes ver el diseño original <a href="https://www.prusaprinters.org/prints/25857-prusa-protective-face-shield-rc2" target="_blank" rel="noreferrer noopener">aquí</a>, el cual se ofrece bajo una licencia <a href="https://creativecommons.org/licenses/by-nc/4.0/" target="_blank" rel="noreferrer noopener">Creative Commons</a>.`
        },
        {
            question: '¿Es este un modelo homologado para uso sanitario?',
            answer: `Ningún dispositivo producido de manera doméstica puede estar homologado. 
                Sin embargo, sí que se puede utilizar como accesorio de protección complementario 
                y bajo la responsabilidad de los propios equipos sanitarios. Este diseño, además, 
                goza de la validación del Ministerio de Sanidad de Rep. Checa.`
        },
        {
            question: '¿Quién cubre mis gastos de impresión y transporte?',
            answer: `Nos encantaría poder asumir tus costes de impresión y transporte, 
                sin embargo estos costes recaen en ti, y tu karma sube. 
                Si en algun momento consiguiéramos algun ingreso económico por esta labor, 
                irá destinado integramente a compensar a todos los que colaboréis.`
        },
        {
            question: '¿Cómo puedo enviaros mis piezas estando en cuarentena?',
            answer: `Si no te es posible desplazarte hasta una oficina de Correos o similar, 
                existen muchas empresas de mensajería con las que puedes contratar envíos y te vendrán a recoger el paquete a casa.`
        },
        {
            question: '¿Qué beneficio económico saca Boxfish Studio de todo esto?',
            answer: `Ninguno. Estamos cubriendo gastos con fondos propios y distribuyendo las pantallas de manera 100% gratuita. 
                Nuestro único interés es colaborar con la lucha contra el COVID-19.`
        },
        {
            question: 'Pero... ¿qué es Boxfish Studio?',
            answer: `Somos un estudio de ingeniería. Ofrecemos servicios de desarrollo de hardware y software, 
                así como asesoramiento técnico y arquitectura de soluciones, de alta calidad, en industrias y tecnologías emergentes.`
        }
    ]

    let activeFaqs
</script>

<style type="text/scss">.hospitals {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.hospitals .hospital {
  background-color: #F0F3F6;
  border-radius: 2px;
  padding: 15px;
  margin-bottom: 10px;
  width: calc(100% / 3 - 10px);
}
/*# sourceMappingURL=src/sections/FAQs.svelte.map */</style>

<div class="wrapper container py-10">
    <div class="content w-full">
        <h1>Preguntas frecuentes</h1>
        <div class="faqs my-10">
            {#each FAQS_LIST as faq, i}
                <FAQ question={faq.question} last={i === FAQS_LIST.length - 1}>
                    {@html faq.answer}
                </FAQ>
            {/each}
        </div>
    </div>
</div>
